import React from "react";
import { ReactComponent as AddIcon } from "../../assets/images/icons/addIcon.svg";

const AddText = () => {
  return (
    <>
      <AddIcon /> Add
    </>
  );
};

const tailwindCommonStyle =
  "flex items-center justify-center gap-1 text-[#DBF6FF] bg-2999BC rounded-md px-2 py-[5px] text-sm font-poppins font-normal w-[50px] ";

const AddButton = ({ className, onClick, isActive, activeText, style = {} }) => {
  return (
    <button
      className={`${tailwindCommonStyle} ${className} ${isActive && !activeText && "opacity-50"}`}
      onClick={onClick}
      style={{ ...style }}
    >
      {isActive && activeText ? activeText : <AddText />}
    </button>
  );
};

export default AddButton;
